/**
 * Tarjetas de beneficios de la PDP (boceto pdp-havaianas).
 *
 * En desktop son tres columnas y las flechas no se ven: el CSS las esconde y
 * este componente no hace nada. Por debajo de 1080px se muestra una tarjeta por
 * vez y las flechas de esa tarjeta navegan entre las tres.
 *
 * El índice vive en un atributo (`data-index`) y no en una clase por tarjeta
 * para que el CSS pueda decidir qué mostrar con un único selector, y para que el
 * estado sobreviva a un resize sin recalcular nada.
 */
if (!customElements.get("product-trust-carousel")) {
  customElements.define(
    "product-trust-carousel",
    class ProductTrustCarousel extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll("[data-trust-card]"));
        if (this.cards.length < 2) return;

        this.index = 0;
        this.addEventListener("click", this.onClick.bind(this));
        this.render();
      }

      onClick(event) {
        const prev = event.target.closest("[data-trust-prev]");
        const next = event.target.closest("[data-trust-next]");
        if (!prev && !next) return;

        this.index = prev
          ? Math.max(0, this.index - 1)
          : Math.min(this.cards.length - 1, this.index + 1);
        this.render();
      }

      render() {
        this.dataset.index = String(this.index);

        this.cards.forEach((card, index) => {
          card.classList.toggle("is-current", index === this.index);

          const prev = card.querySelector("[data-trust-prev]");
          const next = card.querySelector("[data-trust-next]");
          // Los extremos quedan atenuados en vez de desaparecer, como en el
          // boceto: la tarjeta no cambia de ancho al llegar al principio o al
          // final.
          if (prev) prev.classList.toggle("is-inert", this.index === 0);
          if (next) {
            next.classList.toggle(
              "is-inert",
              this.index === this.cards.length - 1
            );
          }
        });
      }
    }
  );
}
